import React, {useEffect, useState} from "react";
import { Route, Switch } from 'react-router';
import { useSelector, useDispatch } from "react-redux";
import {BrowserRouter as Router, Redirect} from 'react-router-dom';

import styles from './Root.module.scss';

import Address from '../Address/Address';
import Bank from '../Bank/Bank';
import CustomDistributionMethod from '../CustomDistributionMethod/CustomDistributionMethod';
import ModalsDisplay from '../../components/Shared/ModalsDisplay/ModalsDisplay';
import Dashboard from '../Dashboard/Dashboard';
import DashboardOld from '../Dashboard/DashboardOld';
import Destination from '../Destination/Destination';
import DistributionMethod from '../ProportionateDistributionMethod/ProportionateDistributionMethod';
import { FooterBeacon } from '@trp-ii-ii-component-library/ii-components';
import Frequency from '../Frequency/Frequency';
import LandingPage from '../landing/LandingPage';
import Reinvest from '../Distribution/Distribution';
import Review from '../Review/Review';
import TaxWithholding from '../TaxWithholding/TaxWithholding';
import ReinvestRMD from '../ReinvestRMD/ReinvestRMD';
import SessionTimer from '../../components/Shared/SessionTimeout/SessionTimeout';
import {appendBasePath} from "../../utils/nav.utils";
import NavigationContainer from '../../components/NavigationContainer/NavigationContainer';
import LandingRedirect from '../../components/Shared/LandingRedirect/LandingRedirect';
import {getCustomerSegmentName} from "../../redux/modules/PersonalInformation/personalInformation.selectors";
import {
  getHasRelationshipManager,
  getRelationshipManagerName
} from "../../redux/modules/manager/relationshipManager.selectors";
import {getHasRetirementFunds, getHasTaxableFunds} from "../../redux/modules/UserFunds/userFunds.selectors";
// import * as moduleActions from "../../redux/modules/applicationData/applicationData.module";
import "./Footer.scss";
import {boolToYesNo} from "../../utils/utils";
import isEmpty from "redux-actions/lib/utils/isEmpty";
import isNil from "redux-actions/lib/utils/isNil";
import {getSelectedMonths} from "../../redux/modules/shoppingCart/shoppingCart.selectors";
import CalculatorDashboard from "../../components/Calculator/CalculatorDashboard/CalculatorDashboard";
import { setAdditionalParams } from "../../redux/modules/applicationConfig/applicationConfig.module";
import { getIsMobileParam } from "../../redux/modules/applicationConfig/applicationConfig.selectors";

const { REACT_APP_BASE_NAME } = process.env;

const Root = (props) => {
  /* Disabled the Test and Target functionality
     will be updated or removed completed at a
     later time
  */

  // const dispatch = useDispatch();
  // const customerInfo = useSelector((state) => state.customer);
  const isTargetUser = useSelector((state) => state.applicationData.testAndTarget);
  const [qualtricsUpdated, updateQualtrics] = useState(false);
    const applicationData = useSelector((state) => state.applicationData);
    const customerSegment =  useSelector(getCustomerSegmentName)
    const hasRelationshipManager =  useSelector(getHasRelationshipManager)
    const hasRetirementFunds =  useSelector(getHasRetirementFunds)
    const hasTaxableFunds =  useSelector(getHasTaxableFunds)
    const personalInformation =  useSelector((state) => state.personalInformation);
    const productTypes =  useSelector((state) => state.userProductTypes.entity || {});
    const relationshipManagerName =  useSelector(getRelationshipManagerName)
    const isMobileParam = useSelector(getIsMobileParam);
    
  /* function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i=0;i < ca.length;i++) {
      let c = ca[i];
      while (c.charAt(0)===' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  } */
  /* eslint-disable */
  // useEffect(() => {
    /* if ( window.location.host.includes('troweprice') ) {
      if (!customerInfo.relationshipManager) {
        const target = getCookie("trp-rmd-test-target");
        if (target) {
          dispatch(
            moduleActions.updateTestAndTarget({target: true})
          );
          return;
        } else {
          const val = Math.floor(Math.random() * Math.floor(100)) + 1;
          const percentTargeted = 0;
          if (val <= percentTargeted) {
            document.cookie = "trp-rmd-test-target=true";
            dispatch(
              moduleActions.updateTestAndTarget({target: true})
            );
            return;
          }
        }
      }
      dispatch(
        moduleActions.updateTestAndTarget({target: false})
      );
    } else {
      dispatch(
        moduleActions.updateTestAndTarget({target: true})
      );
    } */
  // }, []);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setAdditionalParams());
  }, [dispatch]);
  /* eslint-enable */

  if ( isTargetUser === undefined ) {
    return <></>
  }

  const isSandbox = window.location.host.includes('localhost');
  const isInternalDomain = window.location.host.includes('awstrp');
  const isSalesforce =
    window.location.pathname.includes('salesforce') &&
    (isSandbox || isInternalDomain);
  const iFrame = window.location !== window.parent.location && window.location.host.includes('awstrp');
  const showNavElements = !iFrame && !isSalesforce;

  const updateQualtricsAnalytics = () => {
    const {
      hasAPP,
      hasBrokerage,
      hasNAT529: hasN529,
      hasMD529: hasM529,
      hasAK529: hasA529,
    } = productTypes;
    const { age } = personalInformation.data;
    const custSeg = customerSegment;
    const hasRetirement = hasRetirementFunds;
    const hasRM = hasRelationshipManager;
    const hasTaxable = hasTaxableFunds;
    const rmName = relationshipManagerName;
    const qualtricsData = {
      age: Math.floor(age),
      custSeg: isNil(custSeg) ? 'CORE' : custSeg,
      hasAPP: boolToYesNo(hasAPP),
      hasBrokerage: boolToYesNo(hasBrokerage),
      hasA529: boolToYesNo(hasA529),
      hasM529: boolToYesNo(hasM529),
      hasN529: boolToYesNo(hasN529),
      hasRM: boolToYesNo(hasRM),
      hasRetirement: boolToYesNo(hasRetirement),
      hasTaxable: boolToYesNo(hasTaxable),
      rmName: isNil(rmName) ? 'N/A' : rmName,
    };
    if (window && window.trpQualtrics) {
      const qD = {
        ...window.trpQualtrics,
        ...qualtricsData,
      };
      window.trpQualtrics = { ...qD };
    } else {
      if (window) {
        window.trpQualtrics = { ...qualtricsData };
      }
    }
  };

  if (
    !applicationData.isLoading &&
    (applicationData.hasFailed || applicationData.isLoaded) &&
    !qualtricsUpdated
  ) {
    updateQualtricsAnalytics();
    updateQualtrics(true)
  }
  return (
      <div id="beacon-root" className={`${styles.container} beacon-on-light beacon-theme-modern-outlook`}>
        <Router basename={REACT_APP_BASE_NAME}>
          {
            showNavElements &&
            <Route path="/" render={() => <NavigationContainer />} />
          }
          <Switch>
            DashboardOld
            <Route
              exact
              path={[
                appendBasePath(""),
                appendBasePath('/salesforce'),
              ]}
              render={() => <Dashboard {...props} />}
            />
            <Route
              exact
              path={[
                appendBasePath("/old"),
                appendBasePath('/salesforce/old'),
              ]}
              render={() => <DashboardOld {...props} />}
            />
            <Route
              exact
              path={[
                appendBasePath("/calculator"),
                appendBasePath('/salesforce/calculator'),
              ]}
              render={() => <CalculatorDashboard {...props} />}
            />
            {/* These are the paths for Auto-Rmd */}
            <Route
              exact
              path={[
                appendBasePath("/destination"),
                appendBasePath("/salesforce/destination"),
              ]}
              render={() => <div>
                  <LandingRedirect gotToStart>
                    <Destination {...props} />
                  </LandingRedirect>
                </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/edit/destination"),
                appendBasePath("/salesforce/edit/destination"),
              ]}
              render={() => <div>
                <LandingRedirect goToStart>
                  <Destination {...props} edit />
                </LandingRedirect>
              </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/address"),
                appendBasePath("/salesforce/address"),
              ]}
              render={() => <div>
                  <LandingRedirect goToStart>
                    <Address {...props} />
                  </LandingRedirect>
                </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/edit/address"),
                appendBasePath("/salesforce/edit/address"),
              ]}
              render={() => <div>
                <LandingRedirect goToStart>
                  <Address {...props} edit />
                </LandingRedirect>
              </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/bank"),
                appendBasePath("/salesforce/bank"),
              ]}
              render={() => <div>
                  <LandingRedirect goToStart>
                    <Bank {...props} />
                  </LandingRedirect>
                </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/edit/bank"),
                appendBasePath("/salesforce/edit/bank"),
              ]}
              render={() => <div>
                <LandingRedirect goToStart>
                  <Bank {...props} edit />
                </LandingRedirect>
              </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/distribution"),
                appendBasePath("/salesforce/distribution"),
              ]}
              render={() => <div>
                  <LandingRedirect goToStart>
                    <Reinvest {...props} />
                  </LandingRedirect>
                </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/edit/distribution"),
                appendBasePath("/salesforce/edit/distribution"),
              ]}
              render={() => <div>
                <LandingRedirect goToStart>
                  <Reinvest {...props} edit />
                </LandingRedirect>
              </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/proportional"),
                appendBasePath("/salesforce/proportional"),
              ]}
              render={() => <div>
                  <LandingRedirect goToStart>
                    <DistributionMethod {...props} />
                  </LandingRedirect>
                </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/edit/proportional"),
                appendBasePath("/salesforce/edit/proportional"),
              ]}
              render={() => <div>
                <LandingRedirect goToStart>
                  <DistributionMethod {...props} edit />
                </LandingRedirect>
              </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/custom"),
                appendBasePath("/salesforce/custom"),
              ]}
              render={() => <div>
                  <LandingRedirect goToStart>
                    <CustomDistributionMethod {...props} />
                  </LandingRedirect>
                </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/edit/custom"),
                appendBasePath("/salesforce/edit/custom"),
              ]}
              render={() => <div>
                <LandingRedirect goToStart>
                  <CustomDistributionMethod {...props} edit />
                </LandingRedirect>
              </div>
              }
            />
             <Route
              exact
              path={[
                appendBasePath("/reinvest"),
                appendBasePath("/salesforce/reinvest"),
              ]}
              render={() => <div>
                  <LandingRedirect goToStart>
                    <ReinvestRMD {...props} />
                  </LandingRedirect>
                </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/edit/reinvest"),
                appendBasePath("/salesforce/edit/reinvest"),
              ]}
              render={() => <div>
                <LandingRedirect goToStart>
                  <ReinvestRMD {...props} edit />
                </LandingRedirect>
              </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/frequency"),
                appendBasePath("/salesforce/frequency"),
              ]}
              render={() => <div>
                  <LandingRedirect goToStart>
                    <Frequency {...props} />
                  </LandingRedirect>
                </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/edit/frequency"),
                appendBasePath("/salesforce/edit/frequency"),
              ]}
              render={() => <div>
                <LandingRedirect goToStart>
                  <Frequency {...props} edit />
                </LandingRedirect>
              </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/tax-withholding"),
                appendBasePath("/salesforce/tax-withholding"),
              ]}
              render={() => <div>
                  <LandingRedirect goToStart>
                    <TaxWithholding {...props} />
                  </LandingRedirect>
                </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/edit/tax-withholding"),
                appendBasePath("/salesforce/edit/tax-withholding"),
              ]}
              render={() => <div>
                <LandingRedirect goToStart>
                  <TaxWithholding {...props} edit />
                </LandingRedirect>
              </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/review"),
                appendBasePath("/salesforce/review"),
              ]}
              render={() => <div>
                  <LandingRedirect goToStart>
                    <Review {...props} />
                  </LandingRedirect>
                </div>
              }
            />
            <Route
              exact
              path={[
                appendBasePath("/edit/review"),
                appendBasePath("/salesforce/edit/review"),
              ]}
              render={() => <div>
                <LandingRedirect goToStart>
                  <Review {...props} edit />
                </LandingRedirect>
              </div>
              }
            />
            <Route
              path={[
                appendBasePath("/start"),
                appendBasePath("/salesforce/start"),
              ]}
              render={() => <div>
                <LandingRedirect goToStart>
                  <LandingPage />
                </LandingRedirect>
              </div>
              }
            />
            <Route path={appendBasePath('*')}>
              <Redirect to={{ pathname: appendBasePath('/') }} />
            </Route>
          </Switch>
          {
            showNavElements &&
            <FooterBeacon
              productTypes={productTypes}
              applicationData={applicationData}
              customerSegment={customerSegment}
              hasRelationshipManager={hasRelationshipManager}
              hasRetirementFunds={hasRetirementFunds}
              hasTaxableFunds={hasTaxableFunds}
              personalInformation={personalInformation}
              relationshipManagerName={relationshipManagerName}
              isMobileParam={isMobileParam}
            />
          }
          <ModalsDisplay />
        </Router>
      <SessionTimer />
    </div>
  );
};

export default Root;